// extracted by mini-css-extract-plugin
module.exports = {"fit-guarantee":"styles_fit-guarantee__DY8Ca","head":"styles_head__pBI__","icon":"styles_icon__xTa5n"};